import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Emisor } from "src/app/models/Emisor/Emisor";
import { LogoEmisor } from "src/app/models/Emisor/LogoEmisor";
import { LogoEmisorRequest } from "src/app/models/Emisor/LogoEmisorRequest";
import { PlantillaImpresion } from "src/app/models/PlantillaImpresion/PlantillaImpresion";
import { EmisorService } from "src/app/services/emisor.service";
import { LocalStorageService } from "src/app/services/local-storage.service";
import { UtilitiesService } from "src/app/services/utilities.service";
import Swal from "sweetalert2";

@Component({
	selector: "app-logo-emisor-entry",
	templateUrl: "./logo-emisor-entry.component.html",
	styleUrls: ["./logo-emisor-entry.component.scss"],
})
export class LogoEmisorEntryComponent implements OnInit {
	public loading: boolean = false;
	@Input() relatedEmisor: Emisor;
	@Input() public currentLogoEmisor: LogoEmisor;
	@Output() private sendlogoEmisorRequest: EventEmitter<any> = new EventEmitter<any>();
	@Output() private sendCloseRequestEmitter: EventEmitter<any> = new EventEmitter<any>();
	public emisorLogoFormGroup: FormGroup;
	public files: File[] = [];
	public imageFitSource: string[] = ["fill", "contain", "cover", "scale-down", "none"]; // based on object-fit css options
	public logoRequest: LogoEmisorRequest = new LogoEmisorRequest();
	public plantillasPdfDisponibles: PlantillaImpresion[] = [];
	private defaultPlantilla: PlantillaImpresion;
	public filesLogin: File[] = [];
	public logoLoginPreview: string = null;
	constructor(private formBuilder: FormBuilder, private utilities: UtilitiesService, private emisorService: EmisorService, private ref: ChangeDetectorRef, private localStorage: LocalStorageService) {}

	ngOnInit(): void {
		this.setLogoForm();
		this.getCurrentDataToForm();
	}

	ngOnDestroy() {
		this.currentLogoEmisor = undefined;
	}

	setLogoForm() {
		this.emisorLogoFormGroup = this.formBuilder.group({
			logoFile: [null],
			plantillaImpresionPreview: [this.defaultPlantilla],
			permisoPublicitario: [false],
			logoLoginFile: [null]
		});
	}

	closeLogoModal() {
		this.sendCloseRequestEmitter.emit();
	}

	onSelect(event) {
		var fileExtensionName = this.getName(event);
		if (event.rejectedFiles[0] || (fileExtensionName.toLowerCase() != "png" && fileExtensionName.toLowerCase() != "jpg" && fileExtensionName.toLowerCase() != "jpeg")) {
			Swal.fire({
				icon: "error",
				title: "Error de Archivo",
				text: "El archivo ingresado no es de formato de imagen .JPG o .PNG, favor agregar un archivo con el formato correcto. Razón: " + event.rejectedFiles[0].reason == "size" ? "Tamaño" : "Tipo de archivo",
			});
		}

		this.files.push(...event.addedFiles);
		if (this.files.length > 1) {
			this.files.shift();
		}
		this.emisorLogoFormGroup.controls.logoFile.patchValue(this.files[0]);
		this.logoRequest.logoCompleteFile = this.files[0];
		this.logoRequest.nombre = event.addedFiles[0].name;
		this.loading = true;
		this.utilities
			.convertFileToB64String(this.logoRequest.logoCompleteFile)
			.then((data) => {
				this.logoRequest.logoFile = data.split(",")[1];
				this.loading = false;
				this.ref.detectChanges();
			})
			.catch(() => {
				this.loading = false;
				this.ref.detectChanges();
			});
	}
	onRemove(event) {
		this.files.splice(this.files.indexOf(event), 1);
		this.emisorLogoFormGroup.controls.logoFile.patchValue(null);
		this.logoRequest.logoFile = null;
		this.logoRequest.logoCompleteFile = null;

	}

	onSelectLoginLogo(event) {
		if (!event.addedFiles || event.addedFiles.length === 0) {
			if (event.rejectedFiles && event.rejectedFiles.length > 0) {
				Swal.fire({
					icon: "error",
					title: "Error de Archivo",
					text: "El logo para login debe ser en formato PNG y menor a 100 KB."
				});
			}
			return;
		}
		var fileExtensionName = this.getName(event);

		if (fileExtensionName.toLowerCase() !== "png") {
			Swal.fire({
				icon: "error",
				title: "Error de Archivo",
				text: "El logo para login debe ser en formato PNG."
			});
			return;
		}
		const file = event.addedFiles[0];
		if (file.size > 100 * 1024) {
			Swal.fire({
				icon: "error",
				title: "Error de Tamaño",
				text: "El logo para login debe ser menor a 100 KB. Tamaño actual: " + (file.size / 1024).toFixed(2) + " KB"
			});
			return;
		}

		this.filesLogin.push(...event.addedFiles);
		if (this.filesLogin.length > 1) {
			this.filesLogin.shift();
		}
		this.emisorLogoFormGroup.controls.logoLoginFile.patchValue(this.filesLogin[0]);
		this.logoRequest.logoLoginCompleteFile = this.filesLogin[0];
		this.logoRequest.nombreLogoLogin = event.addedFiles[0].name;
		this.loading = true;
		this.utilities.convertFileToB64String(this.logoRequest.logoLoginCompleteFile)
			.then((data) => {
				this.logoRequest.logoLoginFile = data.split(",")[1];
				this.logoLoginPreview = data;
				this.loading = false;
				this.ref.detectChanges();
			})
			.catch(() => {
				this.loading = false;
				this.ref.detectChanges();
			});
	}

	onRemoveLoginLogo(event) {
		this.filesLogin.splice(this.filesLogin.indexOf(event), 1);
		this.emisorLogoFormGroup.controls.logoLoginFile.patchValue(null);
		this.logoRequest.logoLoginFile = null;
		this.logoRequest.logoLoginCompleteFile = null;
		this.logoLoginPreview = null;
		
		if (this.relatedEmisor && this.relatedEmisor.rut) {
			this.loading = true;
			this.emisorService.eliminarLogoPublicitario(this.relatedEmisor.rut).subscribe(
				(response) => {
					this.loading = false;
					this.ref.detectChanges();
					
					if (response.status === 200 && response.data?.success) {
						console.log('Logo publicitario eliminado exitosamente:', response.data.message);
						console.warn('Logo removido localmente pero hubo un problema en el servidor:', response.data?.message);
					}
				},
				(error) => {
					this.loading = false;
					this.ref.detectChanges();
					if (error.status === 404) {
						console.log('Logo no existía en el servidor, solo se removió localmente');
					} else {
						console.error('Error al eliminar logo publicitario:', error);
						Swal.fire({
							icon: 'warning',
							title: 'Advertencia',
							text: 'El logo se removió localmente pero no se pudo eliminar del servidor. Por favor, intente nuevamente.',
							showConfirmButton: true
						});
					}
				}
			);
		}
	}
	

	getName(event): string {
		if (event.addedFiles) {
			return event.addedFiles[0].name.split(".").pop();
		} else if (event.rejectedFiles) {
			return event.rejectedFiles[0].name.split(".").pop();
		} else {
			return "";
		}
	}

	onSubmit(event?: Event) {
		if (event) {
			event.preventDefault();
		}
		const hasLogoDocumentos = this.logoRequest.logoCompleteFile || (this.currentLogoEmisor && this.currentLogoEmisor.logoFile);
		const hasLogoLogin = this.logoRequest.logoLoginCompleteFile || this.filesLogin.length > 0;

		if (!hasLogoDocumentos && !hasLogoLogin) {
			Swal.fire({
				icon: "warning",
				title: "Logo requerido",
				text: "Debe cargar al menos el logo para documentos o el logo para login.",
			});
			return;
		}
    
		this.getLogoFormData();

		if (this.logoRequest.permisoPublicitario && this.relatedEmisor && this.relatedEmisor.rut && hasLogoLogin) {
			this.saveLogoToAssets(!hasLogoDocumentos);
		}
		
		if (hasLogoDocumentos) {
			this.sendlogoEmisorRequest.emit(this.logoRequest);
		} else {
			this.sendCloseRequestEmitter.emit();
		}
		
	}

	base64toBlob(base64Data: string, contentType: string = "", sliceSize: number = 512): Blob {
		const byteCharacters = atob(base64Data);
		const byteArrays = [];

		for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
			const slice = byteCharacters.slice(offset, offset + sliceSize);

			const byteNumbers = new Array(slice.length);
			for (let i = 0; i < slice.length; i++) {
				byteNumbers[i] = slice.charCodeAt(i);
			}

			const byteArray = new Uint8Array(byteNumbers);
			byteArrays.push(byteArray);
		}

		return new Blob(byteArrays, { type: contentType });
	}

	getLogoFormData() {
		this.logoRequest.emisorId = this.relatedEmisor.emisorId;

		let file: File;

		if (this.emisorLogoFormGroup.controls.logoFile.value != null) {
			file = this.emisorLogoFormGroup.controls.logoFile.value;
			this.logoRequest.logoCompleteFile = file;
		} else if (this.currentLogoEmisor && this.currentLogoEmisor.logoFile) {
			let logoFile = this.currentLogoEmisor.logoFile;
			let contentType = "image/png"; // TODO: cambiar por el tipo mime real del archivo
			let blob = this.base64toBlob(logoFile, contentType);
			file = new File([blob], "filename", { type: contentType });
			this.logoRequest.logoFile = logoFile;
		}
		this.logoRequest.fechaSubida = new Date();
		let plantilla = this.emisorLogoFormGroup.controls.plantillaImpresionPreview.value as PlantillaImpresion;
		this.logoRequest.tipoPlantillaIdPreview = plantilla ? plantilla.tipoPlantillaId : undefined;
		this.logoRequest.tipoPlantillaCodigo = plantilla ? plantilla.codigoTipoDte : undefined;
		this.logoRequest.permisoPublicitario = this.emisorLogoFormGroup.controls.permisoPublicitario.value;
		
		if (this.emisorLogoFormGroup.controls.logoLoginFile.value != null) {
			let loginFile = this.emisorLogoFormGroup.controls.logoLoginFile.value;
			this.logoRequest.logoLoginCompleteFile = loginFile;
		}
	}

	async saveLogoToAssets(showSuccessMessage: boolean = false) {
		if (!this.logoLoginPreview || !this.relatedEmisor || !this.relatedEmisor.rut) {
			console.warn('No se puede guardar el logo: faltan datos necesarios');
			return;
		}		
		try {
			const logoBase64 = this.logoLoginPreview.split(',')[1];
			
			const request = {
				emisorId: this.relatedEmisor.emisorId,
				rut: this.relatedEmisor.rut,
				logoLoginBase64: logoBase64,
				permisoPublicitario: this.logoRequest.permisoPublicitario
			};

			this.loading = true;
			this.emisorService.guardarLogoPublicitario(request).subscribe(
				(response) => {
					this.loading = false;
					this.ref.detectChanges();
					if (showSuccessMessage) {
						Swal.fire({
							icon: 'success',
							title: 'Logo guardado',
							text: 'El logo publicitario se guardó correctamente.',
							timer: 2000,
							showConfirmButton: false
						});
					}
				},
				(error) => {
					this.loading = false;
					this.ref.detectChanges();
					
					console.error('Error al guardar logo publicitario:', error);
					const errorMessage = error.error?.errors?.[0] || error.error?.message || 'No se pudo guardar el logo para fines publicitarios.';
					
					Swal.fire({
						icon: 'error',
						title: 'Error al guardar',
						text: errorMessage,
						showConfirmButton: true
					});
				}
			);
			
		} catch (error) {
			this.loading = false;
			this.ref.detectChanges();
			
			console.error('Error al procesar logo para assets:', error);
			Swal.fire({
				icon: 'error',
				title: 'Error',
				text: 'Hubo un problema al procesar el logo. Inténtelo nuevamente.',
			});
		}
	}

	getCurrentDataToForm() {
		if (this.relatedEmisor) {
			this.plantillasPdfDisponibles = this.relatedEmisor.plantillasPdfOfEmisor && this.relatedEmisor.plantillasPdfOfEmisor.length > 0 ? this.relatedEmisor.plantillasPdfOfEmisor : [];
			this.defaultPlantilla = this.plantillasPdfDisponibles.find((plantilla) => plantilla.isDefault);
			//this.emisorLogoFormGroup.controls.plantillaImpresionPreview.patchValue(this.plantillasPdfDisponibles.length > 0 ? this.plantillasPdfDisponibles[0] : undefined);
			this.emisorLogoFormGroup.controls.plantillaImpresionPreview.setValue(this.defaultPlantilla);
			if (this.relatedEmisor.rut) {
				this.cargarLogoPublicitarioExistente();
			}
			this.ref.detectChanges();
		}
	}

	cargarLogoPublicitarioExistente() {
		this.emisorService.existeLogoPublicitario(this.relatedEmisor.rut).subscribe(
			(response) => {
				if (response.status === 200 && response.data?.existe && response.data?.logoBase64) {
					const logoBase64 = response.data.logoBase64;
					const fileName = response.data.fileName;
					
					// Crear el preview directamente desde base64
					this.logoLoginPreview = `data:image/png;base64,${logoBase64}`;
					
					// Crear File desde base64
					const blob = this.base64toBlob(logoBase64, 'image/png');
					const file = new File([blob], fileName, { type: 'image/png' });
					
					this.filesLogin = [file];
					this.emisorLogoFormGroup.controls.logoLoginFile.patchValue(file);
					this.emisorLogoFormGroup.controls.permisoPublicitario.patchValue(true);
					this.logoRequest.logoLoginFile = logoBase64;
					this.logoRequest.logoLoginCompleteFile = file;
					this.ref.detectChanges();
				}
			},
			(error) => {
				if (error.status !== 404) {
					console.warn('Error al obtener logo publicitario:', error);
				}
			}
		);
	}

	previewOfLogo() {
		if (this.emisorLogoFormGroup.valid || this.logoRequest.logoFile || (this.currentLogoEmisor && this.currentLogoEmisor.logoFile)) {
			this.getLogoFormData();
			this.loading = true;
			if (this.logoRequest.tipoPlantillaCodigo < 110) {
				this.emisorService.getLogoPreviewNacional(this.logoRequest).subscribe(
					(result) => {
						this.loading = false;
						this.ref.detectChanges();
						let b64Response = result.data;
						try {
							if (b64Response == "") {
								throw "Respuesta vacía";
							} else {
								this.responseToPdfPreview(b64Response);
							}
						} catch (error) {
							this.loading = false;
							this.ref.detectChanges();
							Swal.fire({
								icon: "error",
								title: "Error al obtener muestra",
								text: "No es posible renderizar la muestra asociada a esta plantilla de impresión.",
							});
						}
					},
					(error) => {
						this.loading = false;
						this.ref.detectChanges();
						Swal.fire({
							icon: "error",
							title: "Error en previsualización",
							text: "No fue posible realizar la previsualización del log agregado, intente nuevamente. " + this.utilities.setErrorMessageFromArray(error.error),
						});
					}
				);
			} else {
				this.emisorService.getLogoPreviewExporta(this.logoRequest).subscribe(
					(result) => {
						this.loading = false;
						this.ref.detectChanges();
						let b64Response = result.data;
						try {
							if (b64Response == "") {
								throw "Respuesta vacía";
							} else {
								this.responseToPdfPreview(b64Response);
							}
						} catch (error) {
							this.loading = false;
							this.ref.detectChanges();
							Swal.fire({
								icon: "error",
								title: "Error al obtener muestra",
								text: "No es posible renderizar la muestra asociada a esta plantilla de impresión.",
							});
						}
					},
					(error) => {
						this.loading = false;
						this.ref.detectChanges();
						Swal.fire({
							icon: "error",
							title: "Error en previsualización",
							text: "No fue posible realizar la previsualización del log agregado, intente nuevamente. " + this.utilities.setErrorMessageFromArray(error.error),
						});
					}
				);
			}
		} else {
			Swal.fire({
				icon: "info",
				title: "Selecciona Logo para Previsualizar",
				text: "Selecciona un nuevo logo para poder previsualizar el logo en el documento seleccionado",
			});
		}
	}

	responseToPdfPreview(responseB64) {
		const pdfBlob = this.utilities.convertB64ToBlob(responseB64, "application/pdf");
		//FileSaver.saveAs(pdfBlob, currentPlantilla.descripcion+"_prueba.pdf");
		if (pdfBlob.size > 0) {
			let fileURL = URL.createObjectURL(pdfBlob);
			this.popupCenter(fileURL, "PDF", 600, 800);
		}
		this.loading = false;
		this.ref.detectChanges();
	}

	popupCenter(url, title, w, h) {
		const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
		const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

		const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
		const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

		const systemZoom = width / window.screen.availWidth;
		const left = (width - w) / 2 / systemZoom + dualScreenLeft;
		const top = (height - h) / 2 / systemZoom + dualScreenTop;
		const newWindow = window.open(
			url,
			title,
			`
      scrollbars=yes,
      width=${w / systemZoom}, 
      height=${h / systemZoom}, 
      top=${top}, 
      left=${left}
      `
		);
		if (window.focus) {
			newWindow.focus();
		}
	}
}
